import { makeStyles } from "tss-react/mui";
import { Box, Stack, IconButton } from "@mui/material";
import { useCallback } from "react";
import { Add as AddIcon, Remove as RemoveIcon, FitScreenOutlined as GpsIcon } from "@mui/icons-material";

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      height: "48px",
      width: "auto",
      zIndex: 10,
      paddingTop: "4px",
      paddingBottom: "4px",
      borderRadius: theme.spacing(1),
      background: theme.palette.background.default,
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
      display: "flex",
      justifyContent: "center",
      boxShadow: "3px 10px 3px 0px rgba(0, 0, 0, 0.00), 2px 6px 3px 0px rgba(0, 0, 0, 0.01), 1px 4px 2px 0px rgba(0, 0, 0, 0.05), 0px 2px 2px 0px rgba(0, 0, 0, 0.09), 0px 0px 1px 0px rgba(0, 0, 0, 0.10)",
    }
  })
);

export default function NavigationButtonWidget(props) {
  const { className, slim, map } = props;
  const { classes } = useStyles();

  const onZoomIn = useCallback(() => {
    map?.zoomIn();
  }, [map]);

  const onZoomOut = useCallback(() => {
    map?.zoomOut();
  }, [map]);

  const onRecenter = useCallback(() => {
    map?.recenter();
  }, [map]);


  return (
    <Box className={`${classes.root} ${className || ""}`}>
      <Stack direction="row">

        {
          !slim ? (
            <>
              <IconButton onClick={onZoomOut} color="primary">
                <RemoveIcon />
              </IconButton>

              <IconButton onClick={onZoomIn} color="primary">
                <AddIcon />
              </IconButton>
            </>
          ) : null
        }

        <IconButton onClick={onRecenter} color="primary">
          <GpsIcon />
        </IconButton>

      </Stack>
    </Box>
  );
}

